/*
 * Copyright (c) 2020. American Express Company
 */

import { InterfaceActionTypeModel } from './interface-action-type.model';
import { UserActionTypeModel } from './user-action.type';

export class DialogTemplateModel {
    id!: number;
    anchor?: string;
    name: string;
    slug: string;
    body: JSX.Element;
    icon?: JSX.Element;
    styles?: Object;
    image?: string;
    imageHeight?: number;
    imageWidth?: number;
    clickAway?: boolean;
    interfaceActionType: InterfaceActionTypeModel[];
    userActionTypes: UserActionTypeModel[];
    created: string;
    updated: string;
    closeAction?: UserActionTypeModel;
    info: string;
    mentor: string;
    hidden?: boolean;
    priority?: number;
    delay?: number;
    dangerous?: boolean;
    mentorX?: number;
    mentorY?: number;
    mentorHeight: number;
}
